import React, { useEffect, useState } from "react";
import { Checkbox, Modal } from "rsuite";
import { WireBenchmarkItem } from "../../services/interfaces/IBusinessCostSetting";

interface IWirePopupModalProps {
    isOpen: boolean;
    district: string;
    items: WireBenchmarkItem[];
    onApproveAll: (selectedItems: WireBenchmarkItem[]) => void;
    onSubmit12STR: (selectedItems: WireBenchmarkItem[]) => void;
    onClose: () => void;
    isRetainFlow?: boolean;
}

const WirePopupModal = ({
    isOpen,
    district,
    items,
    onApproveAll,
    onSubmit12STR,
    onClose,
    isRetainFlow = false,
}: IWirePopupModalProps) => {
    const displayItems = items.filter((item) => item.base_sku !== "THHN 12STR");
    const [selectedLabels, setSelectedLabels] = useState<string[]>([]);

    useEffect(() => {
        setSelectedLabels(displayItems.map((item) => item.base_sku));
    }, [items, isOpen]);

    const handleToggleItem = (label: string, checked: boolean) => {
        setSelectedLabels((prev) =>
            checked
                ? [...prev, label]
                : prev.filter((selectedLabel) => selectedLabel !== label)
        );
    };

    const selectedItems = displayItems.filter((item) =>
        selectedLabels.includes(item.base_sku)
    );

    const formatBoardCostValue = (value?: number | null) => {
        if (value === null || value === undefined) {
            return "-";
        }

        const numericValue = Number(value);

        return `$${numericValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        })}`;
    };

    const getApproveAllItems = () => {
        const thhn12STR = items.find((item) => item.base_sku === "THHN 12STR");
        return thhn12STR ? [thhn12STR, ...selectedItems] : selectedItems;
    };

    return (
        <div className="flex justify-center items-center">
            <Modal
                className="w-[30vw] quote-upload-modal"
                open={isOpen}
                onClose={onClose}
                backdrop="static"
                keyboard={false}
                size="xs"
            >
                <Modal.Header>
                    <p className="text-[0.95vw] font-semibold leading-[1.45] text-[#2b2b2b]">
                        {isRetainFlow
                            ? <>Retain Current Board Cost for other{" "}
                                <span className="text-deloitteGreen font-bold">
                                    {district}
                                </span>{" "}
                                wire categories?</>
                            : <>Submit other{" "}
                                <span className="text-deloitteGreen font-bold">
                                    {district}
                                </span>{" "}
                                wire category benchmarks using this board cost and benchmark ratios?</>
                        }
                    </p>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-[0.5vw] pt-[0] pb-0">
                        <div className="mt-0 flex flex-col gap-[5px] text-[0.92vw] text-[#4a4a4a]">
                            {displayItems.map((item) => {
                                const isChecked = selectedLabels.includes(item.base_sku);

                                return (
                                    <Checkbox
                                        key={item.base_sku}
                                        checked={isChecked}
                                        onChange={(_, checked) =>
                                            handleToggleItem(item.base_sku, checked)
                                        }
                                    >
                                        <span className="font-medium">{isRetainFlow ? "Retain " : ""}{item.base_sku}:</span>{" "}
                                        <span>{formatBoardCostValue(item.actual_board_cost ?? item.finalized_business_cost)}</span>
                                    </Checkbox>
                                );
                            })}
                        </div>

                        <div className="mt-[2.5vh] flex justify-center gap-[0.8vw]">
                            <button
                                onClick={() => onApproveAll(getApproveAllItems())}
                                className="min-w-[12vw] rounded bg-deloitteGreen px-[0.9vw] py-[0.9vh] text-[0.85vw] font-semibold text-white"
                            >
                                Yes, approve all boards
                            </button>

                            <button
                                onClick={() => onSubmit12STR(selectedItems)}
                                className="min-w-[10vw] rounded bg-[#A7A7A7] px-[0.9vw] py-[0.9vh] text-[0.85vw] font-semibold text-white"
                            >
                                No, only submit 12STR board
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default WirePopupModal;